const f = typeof window.requestIdleCallback == "function" ? window.requestIdleCallback : setTimeout,
  p = typeof window.cancelIdleCallback == "function" ? window.cancelIdleCallback : clearTimeout;
function b(e, t) {
  let n;
  function i(...a) {
    (clearTimeout(n), (n = setTimeout(() => e.apply(this, a), t)));
  }
  return (
    (i.cancel = () => {
      clearTimeout(n);
    }),
    i
  );
}
function y(e, t, n = { subtree: !0 }) {
  const a = (Array.isArray(e) ? e.flatMap((r) => r.getAnimations(n)) : e.getAnimations(n)).reduce(
    (r, s) => (s.timeline instanceof DocumentTimeline && r.push(s.finished), r),
    []
  );
  return Promise.allSettled(a).then(t);
}
const m = matchMedia("(prefers-reduced-motion: reduce)");
function h() {
  return m.matches;
}
function I(e) {
  const t = document.createElement("div");
  return ((t.textContent = e), t.innerHTML);
}
function g(e, t) {
  let n = 0;
  return function (...i) {
    const a = Date.now();
    if (a - n >= t) return ((n = a), e.apply(this, i));
  };
}
function w(e, { locale: t = "de-DE", currency: n = "EUR" } = {}) {
  if (typeof e != "number" || isNaN(e)) return "";
  const i = e / 100;
  return new Intl.NumberFormat(t, {
    style: "currency",
    currency: n,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(i);
}
function E(e, t) {
  customElements.get(e) || customElements.define(e, t);
}
function A(e, t, n) {
  const i = [
    ".carousel-slide[data-media-position]",
    ".carousel-thumbnail[data-media-position]",
    ".product-media-grid-item[data-media-position]",
  ];
  for (const c of i) {
    const d = Array.from(e.querySelectorAll(c));
    d.forEach((o) => {
      const l = parseInt(o.dataset.mediaPosition, 10);
      if (Number.isNaN(l)) {
        o.classList.remove("media-hidden");
        return;
      }
      o.classList.toggle("media-hidden", !(l >= t && l < n));
    });
    const u = d.find((o) => o.dataset.mediaPosition === "ablyft-media");
    if (u) {
      const o = d.find((l) => parseInt(l.dataset.mediaPosition, 10) === t);
      o && u.previousElementSibling !== o && o.insertAdjacentElement("afterend", u);
    }
  }
  const a = Array.from(e.querySelectorAll(".product-media-grid-item[data-media-position]"));
  a.forEach((c) => c.classList.remove("col-span-2"));
  const r = a.find((c) => {
    const d = parseInt(c.dataset.mediaPosition, 10);
    return !Number.isNaN(d) && !c.classList.contains("media-hidden");
  });
  r && r.classList.add("col-span-2");
  const s = e.querySelector("carousel-embla");
  s?.embla &&
    (typeof s.embla.reInit == "function" && s.embla.reInit({ startSnap: 0 }),
    typeof s.embla.goTo == "function" && s.embla.goTo(0, !0));
}
export { b as a, p as c, E as d, I as e, w as f, y as o, h as p, f as r, g as t, A as u };
